import { render, staticRenderFns } from "./AgeRange.vue?vue&type=template&id=9d5a3b7a&"
import script from "./AgeRange.vue?vue&type=script&lang=ts&"
export * from "./AgeRange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports